import { render, staticRenderFns } from "./ChatBuyerProfileSide.vue?vue&type=template&id=c3886c84&scoped=true"
import script from "./ChatBuyerProfileSide.vue?vue&type=script&lang=js"
export * from "./ChatBuyerProfileSide.vue?vue&type=script&lang=js"
import style0 from "./ChatBuyerProfileSide.vue?vue&type=style&index=0&id=c3886c84&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3886c84",
  null
  
)

export default component.exports